import React from 'react';

// import { AppsFilterGlyph } from '../../../constants/icons/app-filter';
// import { FolderOpenGlyph } from '../../../constants/icons/folder-open';
// import { LabelGlyph } from '../../../constants/icons/label';
// import { PersonGlyph } from '../../../constants/icons/person';
import AssetsSchemaIcon from '@atlaskit/icon-lab/core/assets-schema';
import JobFamilyIcon from '@atlaskit/icon/core/briefcase';
import CalendarIcon from '@atlaskit/icon/core/calendar';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import CustomizeIcon from '@atlaskit/icon/core/customize';
import FileIcon from '@atlaskit/icon/core/files';
import FocusAreaIcon from '@atlaskit/icon/core/focus-area';
import FolderClosedIcon from '@atlaskit/icon/core/folder-closed';
import BulletedListIcon from '@atlaskit/icon/core/list-bulleted';
import PersonIcon from '@atlaskit/icon/core/person';
import PersonAddedIcon from '@atlaskit/icon/core/person-added';
import ProjectIcon from '@atlaskit/icon/core/project';
import SortDescendingIcon from '@atlaskit/icon/core/sort-descending';
import StatusVerifiedIcon from '@atlaskit/icon/core/status-verified';
import TagIcon from '@atlaskit/icon/core/tag';
import TeamsIcon from '@atlaskit/icon/core/teams';
import { token } from '@atlaskit/tokens';

import { type FilterOrControlId } from '../../../constants/filters/types';

export const getIcon = ({
	filterOrControlId,
	isSelected,
	label = '',
}: {
	filterOrControlId: FilterOrControlId;
	isSelected: boolean;
	label?: string;
}): React.JSX.Element | null | undefined => {
	switch (filterOrControlId) {
		case 'owner':
		case 'assignee':
		case 'contributor':
		case 'createdBy':
			return (
				<PersonIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'verified':
			return (
				<StatusVerifiedIcon
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'label':
			return (
				<TagIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'content':
			return (
				<BulletedListIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'focusAreaType':
		case 'focusAreaUnder':
		case 'positionFocusArea':
			return (
				<FocusAreaIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'lastUpdated':
		case 'closeDate':
			return (
				<CalendarIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'project':
			return (
				<ProjectIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'space':
			return (
				<FolderClosedIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'onlyTitleMatch':
			return null; // Title match doesn't show an icon, only a checkbox
		case 'pageStatus':
			return (
				<CheckCircleIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'lastUpdatedBy':
			return (
				<PersonIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'universalTypeFilter':
			return (
				<FileIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'dropdown':
			return (
				<CustomizeIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'sort':
			return (
				<SortDescendingIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'assetsSchema':
			return (
				<AssetsSchemaIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'positionTeam':
			return (
				<TeamsIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'positionEmploymentType':
		case 'positionStatus':
			return (
				<PersonAddedIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'positionJobFamily':
			return (
				<JobFamilyIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
	}
};
